const chainPromises = (tasks = []) =>
  tasks.reduce(
    (promise, task) => promise.then(result => task().then([].concat.bind(result))),
    Promise.resolve([]),
  );

export default chainPromises;
